import {useState, useEffect} from 'react';
import sanityClient from "../client";

export function usePosts () {
    const [posts, setPosts] = useState(null)
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const getPosts = async() =>{
            try{
                setPosts(await sanityClient.fetch(`*[_type == "post"] | order(order asc){
                    _id,
                    title
                }`))
                setLoading(false)
            }
            catch (error){
                console.log(error);
            }
        }
        getPosts()
    }, [])
    return {
        posts,
        loading
    }
}
export function usePostsSlider () {
    const [images, setImages] = useState(null)
    // const [loading, setLoading] = useState(true)
    useEffect(() => {
        const getPosts = async() =>{
            try{
                setImages(await sanityClient.fetch(`*[_type == "post" && slider.show_project == true][0...12] | order(order asc){
                    _id,
                    title,
                    slider
                }`))
                // setLoading(false)
            }
            catch (error){
                console.log(error);
            }
        }
        getPosts()
    }, [])
    return {
        images
    }
}
export function usePost (_id , index) {
    const [post, setPost] = useState(null)
    const [prev, setPrev] = useState(null)
    const [next, setNext] = useState(null)
    const [loadingOne, setloadingOne] = useState(true)
    const { posts, loadingTwo } = usePosts();
    
    useEffect(() => {
        const getPost = async() =>{
            try{
                setPost(await sanityClient.fetch(`*[_id == "${_id}"]{
                    title,
                    slug,
                    body,
                    imagesGallery
                }`))
                setPrev(await posts[parseInt(index) - 1])
                setNext(await posts[parseInt(index) + 1]) 
                setloadingOne(false)
            }
            catch (error){
                console.log(error);
            }
        }
        getPost()
      }, [index, posts, _id]);
    return {
        post,
        loadingOne,
        loadingTwo,
        prev,
        next
    }
}



